import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, vModelDynamic as _vModelDynamic, withKeys as _withKeys, withDirectives as _withDirectives, vModelText as _vModelText, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "mb-1"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 2,
  class: "contents"
};
const _hoisted_4 = {
  class: "shrink-0 text-xs"
};
const _hoisted_5 = ["value"];
const _hoisted_6 = {
  key: 4,
  class: "h-[24px] w-px bg-current opacity-50 shrink-0"
};
const _hoisted_7 = {
  key: 5,
  class: "flex items-center gap-2 overflow-hidden"
};
const _hoisted_8 = {
  key: 0,
  class: "truncate"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 6,
  class: "contents"
};
const _hoisted_11 = ["type"];
const _hoisted_12 = {
  key: 8,
  class: "icon-chevron-down text-xs ml-auto"
};
const _hoisted_13 = {
  key: 1,
  class: "absolute w-full top-full left-0 z-30"
};
const _hoisted_14 = {
  class: "input-field-menu-container max-h-[160px] flex flex-col rounded-b overflow-y-auto scroll-main border! border-transparent overflow-hidden"
};
const _hoisted_15 = ["onKeydown", "onClick"];
const _hoisted_16 = ["innerHTML", "title"];
const _hoisted_17 = {
  class: "h-full flex items-center gap-2 ml-auto"
};
const _hoisted_18 = {
  key: 0,
  class: "input-field-menu-item-island hidden group-hover:flex animate-fade"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScrollShadow = _resolveComponent("ScrollShadow");
  const _component_InfoComponent = _resolveComponent("InfoComponent");
  return _openBlock(), _createElementBlock("div", _mergeProps({
    class: ["h-fit w-full relative", [$props.variant, $props.size, {
      'error': this.validationStatus?.hasError
    }]]
  }, $options.bindedInputFieldAttributes), [_ctx.label ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.label), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["input-field-container relative flex items-center rounded transition-[boxShadow]", [{
      'focus': _ctx.focus
    }, {
      'cursor-pointer': this.isSelector
    }, {
      'rounded-b-none': this.isSelector && _ctx.focus && this.filteredItemsBySearch?.length
    }]])
  }, [_ctx.icon ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    class: _normalizeClass(["input-field-icon", _ctx.icon])
  }, null, 2)) : _createCommentVNode("", true), _ctx.image ? (_openBlock(), _createElementBlock("img", {
    key: 1,
    class: "input-field-icon",
    src: _ctx.image
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _ctx.hintText ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$st(_ctx.hintText)), 1), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "h-6 w-px bg-main-100/20 shrink-0"
  }, null, -1))])) : _createCommentVNode("", true), $props.type === 'tel' ? (_openBlock(), _createElementBlock("input", _mergeProps({
    key: 3,
    class: "bg-transparent",
    style: {
      "width": "3ch"
    },
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    value: $props.prefix,
    onInput: _cache[1] || (_cache[1] = $event => _ctx.$emit('update:prefix', $event.currentTarget.value))
  }, $options.bindedInputAttributes), null, 16, _hoisted_5)) : _createCommentVNode("", true), $props.type === 'tel' ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), $options.selectedItems?.length && !_ctx.focus ? (_openBlock(), _createElementBlock("div", _hoisted_7, [$options.selectedItems?.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($options.selectedItems.map(i => i.label).join(', ')), 1)) : (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: "flex items-center truncate",
    innerHTML: $options.selectedItems[0]?.label
  }, null, 8, _hoisted_9))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [!$props.textarea ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
    key: 0,
    class: "input-field-input h-full w-full bg-transparent outline-none transition-colors cursor-text",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => this.computedValue = $event),
    onKeydown: _cache[3] || (_cache[3] = _withKeys($event => this.$emit('enter'), ["enter"])),
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
    type: _ctx.showPassword ? 'text' : $props.type
  }, $options.bindedInputAttributes), null, 16, _hoisted_11)), [[_vModelDynamic, this.computedValue]]) : _withDirectives((_openBlock(), _createElementBlock("textarea", _mergeProps({
    key: 1,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => this.computedValue = $event),
    class: "input-field-input min-h-[80px] w-full bg-transparent outline-none transition-colors py-3 scroll-hidden cursor-text",
    onKeydown: _cache[6] || (_cache[6] = _withKeys($event => this.$emit('enter'), ["enter"])),
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
  }, $options.bindedInputAttributes), null, 16)), [[_vModelText, this.computedValue]])])), $props.quickClean && _ctx.value ? (_openBlock(), _createElementBlock("i", {
    key: 7,
    class: "icon-cross-rounded text-current text-lg cursor-pointer hover:scale-105 active:scale-100 origin-center transition-transform",
    onClick: _cache[8] || (_cache[8] = $event => _ctx.value = undefined)
  })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true), this.isSelector ? (_openBlock(), _createElementBlock("i", _hoisted_12)) : $props.type === 'password' ? (_openBlock(), _createElementBlock("i", {
    key: 9,
    class: _normalizeClass(["password-icon cursor-pointer", _ctx.showPassword ? 'icon-eye-open' : 'icon-eye-closed']),
    onClick: _cache[9] || (_cache[9] = _withModifiers($event => _ctx.showPassword = !_ctx.showPassword, ["stop"]))
  }, null, 2)) : _createCommentVNode("", true)], 2), this.isSelector && _ctx.focus && this.filteredItemsBySearch?.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_ScrollShadow, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.filteredItemsBySearch, item => {
      return _openBlock(), _createElementBlock("div", {
        key: item,
        class: _normalizeClass(["input-field-menu-item group flex items-center gap-2 transition-[background] duration-200 overflow-hidden shrink-0", {
          'selected': this.IsSelected(item)
        }]),
        tabindex: "0",
        onKeydown: _withKeys($event => $options.handleItemClick(item), ["enter"]),
        onClick: _withModifiers($event => $options.handleItemClick(item), ["stop"])
      }, [_createElementVNode("p", {
        class: "truncate",
        innerHTML: item.label,
        title: item.label
      }, null, 8, _hoisted_16), _createElementVNode("div", _hoisted_17, [item.island?.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.island, islandItem => {
        return _openBlock(), _createElementBlock("i", _mergeProps({
          key: islandItem,
          ref_for: true
        }, islandItem, {
          class: "button-hover text-sm p-1"
        }), null, 16);
      }), 128))])) : _createCommentVNode("", true), _cache[11] || (_cache[11] = _createElementVNode("i", {
        class: "hidden in-[.selected]:block! icon-check text-2xs"
      }, null, -1))])], 42, _hoisted_15);
    }), 128))])]),
    _: 1
  })])) : _createCommentVNode("", true), _createVNode(_component_InfoComponent, {
    data: _ctx.validationStatus,
    class: "mt-1.5"
  }, null, 8, ["data"])], 16);
}